// removed by extract-text-webpack-plugin
module.exports = {"loader":"Loader-module-loader-kpm_V","icon":"Loader-module-icon-2rrTy"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Loader/Loader.module.scss
// module id = 936
// module chunks = 0